const getBooleanEnvState = (state:string | undefined) => {
  if (state === 'true') return true;
  if (state === 'false') return false;
  return undefined;
};

export default {
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '6Lftb1kjAAAAACTllCceIQ3wgaz32ActSwdCrrAw',
  STATUS: getBooleanEnvState(process.env.REACT_APP_RECAPTCHA_STATUS) !== undefined
    ? getBooleanEnvState(process.env.REACT_APP_RECAPTCHA_STATUS)
    : true
};
